let locks = 0;
let saved: { overflow: string; paddingRight: string } | null = null;

const keepsGutter = () =>
  typeof CSS !== "undefined" && !!CSS.supports?.("scrollbar-gutter", "stable");

/**
 * Stops the page behind an overlay from scrolling without shifting it. The
 * html `scrollbar-gutter: stable` keeps the scrollbar's space where it is
 * supported; elsewhere the body is padded by the scrollbar width. Nested
 * locks are counted, so the page unlocks when the last overlay closes.
 * Returns the unlock function.
 */
export const lockBodyScroll = () => {
  const { body, documentElement } = document;
  if (locks === 0) {
    saved = {
      overflow: body.style.overflow,
      paddingRight: body.style.paddingRight,
    };
    const scrollbar = window.innerWidth - documentElement.clientWidth;
    if (!keepsGutter() && scrollbar > 0) {
      // The stylesheet gives body no padding (Styles/index.scss).
      const padding = parseFloat(saved.paddingRight) || 0;
      body.style.paddingRight = `${padding + scrollbar}px`;
    }
    body.style.overflow = "hidden";
  }
  locks += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    locks -= 1;
    if (locks === 0 && saved) {
      body.style.overflow = saved.overflow;
      // removeProperty: jsdom ignores setting padding to "".
      if (saved.paddingRight) body.style.paddingRight = saved.paddingRight;
      else body.style.removeProperty("padding-right");
      saved = null;
    }
  };
};
